export default Object.freeze({
    LENS_FRONT_DESIGN_STD: '/img/designer-pictures/LENS_FRONT_DESIGN_STD@2x.png',
    LENS_FRONT_DESIGN_FS:  '/img/designer-pictures/LENS_FRONT_DESIGN_FS@2x.png',
});
